// BCF 3.0 parser (§35). Tenký wrapper nad sdíleným, verzně tolerantním parserem.
import { parseBCFArchive } from "./BCFParser.js";
export class BCF30Parser {
  parse(files) { return parseBCFArchive(files, "3.0"); }
}
